import IconInfo from '@apollo/icons/default/IconInfo.svg';
import { Link } from '@apollo/orbit';
import React from 'react';

import { fieldRouteConfig } from 'src/app/graph/routes';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { useRouteParams } from 'src/hooks/useRouteParams';
import { CoordinateKind } from 'src/lib/graphqlTypes/types';
import { DocsRouter } from 'src/lib/routers';

export type MetricInfoType = 'executionCount' | 'referencingOperationCount';

const friendlyCoordinateKind = new Map<CoordinateKind, string>([
  [CoordinateKind.ENUM_VALUE, 'enum value'],
  [CoordinateKind.INPUT_OBJECT_FIELD, 'input field'],
  [CoordinateKind.OBJECT_FIELD, 'field'],
]);

export const MetricInfoTooltip = ({ type }: { type: MetricInfoType }) => {
  const { coordinateKind = CoordinateKind.OBJECT_FIELD } =
    useRouteParams(fieldRouteConfig);

  return (
    <Tooltip
      openDelay={200}
      interactive
      placement="bottom-end"
      label={
        <div className="text-start font-normal normal-case">
          {type === 'executionCount' ? (
            <>
              How many times the resolver for this{' '}
              {friendlyCoordinateKind.get(coordinateKind)} has been executed.
            </>
          ) : (
            <>
              How many times an operation that requests this{' '}
              {friendlyCoordinateKind.get(coordinateKind)} has been observed.
            </>
          )}{' '}
          For details, see the{' '}
          <Link isExternal to={DocsRouter.path('FieldsUsage')}>
            Studio documentation
          </Link>
          .
        </div>
      }
    >
      <IconInfo />
    </Tooltip>
  );
};
